import { lodash, lfp } from './lodash';
import { pipe } from './pipe';
import { shallowEqual } from './shallowEqual';
import * as collection from './collection';
import * as misc from './misc';
import * as string from './string';
import * as object from './object';
import { default as deepEqual } from 'deep-equal';
import { nameSplitter } from './nameSplitter';

export const R = {
  pipe,

  ...lodash,
  ...collection.fns,

  ops: {
    ...lfp,
    ...collection.ops,
  },
  deepEqual,

  shallowEqual,
  nameSplitter,
  ...misc,
  ...string,
  ...object,
};
